import { Component, OnInit } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-terms-of-sale',
  templateUrl:  `./${environment.pageFolder}/terms-of-sale.${environment.pageFolder}.component.html`,
  styleUrls:  [`./${environment.pageFolder}/terms-of-sale.${environment.pageFolder}.component.sass`],
  standalone: true,
  imports: [TranslateModule]
})
export class TermsOfSaleComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {
    window.scrollTo(0, 0);
    const loader = document.getElementById("loader-container");
    loader!.style.display = 'none';
  }
}
